import isNil from 'lodash/isNil';

import { libxConfig } from '../../config';

import { showNotification } from '../notifications/actions';

import { ReducedMarketplaceProductOut } from '../apiLibx';
import {
    LIBX_LOCAL_REGIONS_SET_LOCAL_REGION,
    LIBX_UPDATE_PRODUCT_IN_PRODUCT_LIST_FAILURE,
    LIBX_UPDATE_PRODUCT_IN_PRODUCT_LIST_REQUEST,
    LIBX_UPDATE_PRODUCT_IN_PRODUCT_LIST_SUCCESS,
    LibxLocalRegionsSetLocalRegion,
    LibxUpdateProductInProductListFailure,
    LibxUpdateProductInProductListRequest,
    LibxUpdateProductInProductListSuccess
} from './types';
import { AppDispatch } from '../index';
import i18n from '../../../i18n';
import { http } from '../../api/axios';

const config = libxConfig();

export const setSelectedLocalRegion = (region: string): LibxLocalRegionsSetLocalRegion => {
    return { type: LIBX_LOCAL_REGIONS_SET_LOCAL_REGION, payload: region };
};

const updateProductInProductsListRequest = (): LibxUpdateProductInProductListRequest => {
    return { type: LIBX_UPDATE_PRODUCT_IN_PRODUCT_LIST_REQUEST };
};
const updateProductInProductsListSuccess = (
    resp: ReducedMarketplaceProductOut
): LibxUpdateProductInProductListSuccess => {
    return { type: LIBX_UPDATE_PRODUCT_IN_PRODUCT_LIST_SUCCESS, payload: resp };
};
const updateProductInProductsListFailure = (): LibxUpdateProductInProductListFailure => {
    return { type: LIBX_UPDATE_PRODUCT_IN_PRODUCT_LIST_FAILURE };
};

export const updateProductInProductsList = productId => dispatch => {
    dispatch(updateProductInProductsListRequest());
    return http
        .get(config.endpointProductReduced, { pathParams: { id: productId } })
        .then(response => {
            dispatch(updateProductInProductsListSuccess(response.data));
        })
        .catch(() => {
            dispatch(updateProductInProductsListFailure());
        });
};

export const addToCollection = (productId: string) => {
    return (dispatch: AppDispatch) => {
        if (isNil(productId)) {
            return;
        }

        const pathParams = {
            action: 'add',
            id: productId
        };

        const request = http.post(config.endpointCollection, {}, { pathParams });

        request.then(() => {
            dispatch(showNotification(i18n.t('notifications.addToCollection.success')));
        });

        return request;
    };
};

export const removeLocalContentCopies = (productId: string) => {
    return (dispatch: AppDispatch) => {
        const pathParams = { productId };
        return http
            .delete(config.endpointProductCopiesRemove, { pathParams })
            .then(response => {
                dispatch(showNotification(i18n.t('notifications.removeLocalContentCopies.success')));
                return response.data;
            })
            .catch(error => {
                return Promise.reject(error);
            });
    };
};
